// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React, { ReactElement } from "react";
import { Redirect, Route } from "react-router-dom";
import Login from "../../pages/login/login";
import { MessageFormatHandler } from "../messageBox/messageBox";
import { getDarkTheme, getPrimaryBlueTheme } from "../../../../common/themes";
/*import {
    Customizer,
    Dialog,
    DialogFooter,
    DialogType,
    ICustomizations,
    ITheme,
    PrimaryButton,
} from "office-ui-fabric-react";*/

import {
    Customizer,
    Dialog,
    DialogFooter,
    DialogType,
    ICustomizations,
    ITheme,
    PrimaryButton,
} from "@fluentui/react";

/**
 * Properties for Alert Component
 * @member closeButtonText - Text displayed on 'Close' button. Default 'OK'
 * @member onClose - Function to execute on alert close
 * @member confirmButtonTheme - Theme of 'Confirm' button
 */
export interface IAlertProps {
    title?: string;
    message: string | ReactElement<any> | MessageFormatHandler;
    closeButtonText?: string;
    confirmButtonTheme?: ITheme;
    show?: boolean;
    errorCode?: any;
    onClose?: () => void;
}

/**
 * State for Alert Component
 * @member params - Arguments passed in the open command
 */
export interface IAlertState {
    params: any[];
    redirect: boolean;
}

/**
 * @name - Alert
 * @description - Generic Alert dialog
 */
export default class Alert extends React.Component<IAlertProps, IAlertState> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            params: null,
            redirect: false,
        };
        this.onCloseClick = this.onCloseClick.bind(this);
    }

    public render() {
        const dark: ICustomizations = {
            settings: {
              theme: getDarkTheme(),
            },
            scopedSettings: {},
        };
        const confirmButtonTheme = this.props.confirmButtonTheme;

        return (
            <>
            {!this.state.redirect ? <Customizer {...dark}>
                {this.props.show &&
                    <Dialog
                        onDismiss={this.onCloseClick}
                        hidden={!this.props.show}
                        dialogContentProps={{
                            type: DialogType.normal,
                            title: this.props.title,
                            subText: this.getMessage(this.props.message),
                        }}
                        modalProps={{
                            isBlocking: this.props.errorCode === 401 ? true : false,
                        }}
                        >
                        <DialogFooter>
                            <PrimaryButton
                                theme={getPrimaryBlueTheme()}
                                onClick={this.onCloseClick}
                                text={this.props.closeButtonText || "OK"}/>
                        </DialogFooter>
                    </Dialog>
                }
            </Customizer> :
              <Redirect to="/login" />
            }
            </>
        );
    }

    private onCloseClick() {
        if (this.props.errorCode === 401) {
            this.setState({ redirect: true });
        } else {
        // if (this.props.onClose && this.props.errorCode !== 401) {
            this.props.onClose.apply(null, this.state.params);
        // }
        }
    }

    private getMessage = (message: string | MessageFormatHandler | ReactElement<any>) => {
        if (typeof message === "function") {
            return message.apply(this, this.state.params);
        } else {
            return message;
        }
    }

}
